export const fieldsToHide = [
  'id',
  'user_id',
  'client_id',
  'thorough_explanation_as_to_how_each_field_was_determined',
  'currency',
  'explanation_of_fields',
  'logo_uri',
  'created_at',
  'has_feed_data',
  'is_updated_automatically',
];

export function camelCaseOrSnakeCaseToWords(s: string) {
  if (s === 'uk_residency_status') {
    return 'UK residency status';
  }

  if (s.includes('_') || s.toUpperCase() === s) {
    const result = s.toLowerCase().replace(/_/g, ' ').toLowerCase().trim();
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  const result = s
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .trim();

  return result.charAt(0).toUpperCase() + result.slice(1);
}
